module.exports = [
  // decomposition
  require('./decomposition/lup'),
  require('./decomposition/slu'),

  // solver
  require('./solver/lsolve'),
  require('./solver/lusolve'),
  require('./solver/usolve')
];



//////////////////
// WEBPACK FOOTER
// D:/projects/neg5/neg5.main/node_modules/mathjs/lib/function/algebra/index.js
// module id = 447
// module chunks = 0